import OneSignal from 'react-onesignal';

export const runOneSignal = async (userData) => {
  const externalUserId = userData && userData.user && userData.user.id;
  const oneSignalAppId = Env.ONE_SIGNAL_APP_ID;

  try {
    // Unregister any existing service workers
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.unregister();
    }
    await OneSignal.init({
      appId: oneSignalAppId,
      serviceWorkerPath: '/serviceworker.js',
      notifyButton: {
        enable: true,
      },
      allowLocalhostAsSecureOrigin: true,
    });
    OneSignal.on('notificationDisplay', (event) => {});

    OneSignal.on('subscriptionChange', async (isSubscribed) => {
      if (isSubscribed) {
        try {
          await OneSignal.setExternalUserId(externalUserId);
        } catch (error) {
          console.error('Error setting external user ID:', error);
        }
      }
    });

    // Check initial subscription state and permissions
    await OneSignal.isPushNotificationsEnabled();

    const permission = await OneSignal.getNotificationPermission();

    if (permission === 'default') {
      OneSignal.showSlidedownPrompt();
    } else if (permission === 'granted') {
      const externalId = await OneSignal.getExternalUserId();
      if (externalId && externalUserId !== externalId) {
        await OneSignal.setExternalUserId(externalUserId);
      }
    }
  } catch (error) {
    console.error('Error initializing OneSignal:', error);
  }
};

export const disablePushNotifications = async () => {
  try {
    await OneSignal.setSubscription(false);
  } catch (error) {
    console.error('Error disabling push notifications:', error);
  }
};
